import { useState, useCallback } from 'react';
import { contratosAPI } from '../services/api';

const errorDe = (error, porDefecto) => error.response?.data?.error || porDefecto;

/**
 * Contratos con proveedores: por cada proveedor, el contrato que cubre el mes
 * consultado, la tarifa vigente de cada herramienta y el catálogo activo.
 * Las acciones devuelven true/false y notifican el error del servidor.
 */
export const useContratos = (showNotification) => {
  const [datos, setDatos] = useState(null); // { periodo, proveedores: [...] }
  const [loading, setLoading] = useState(false);

  const loadVigentes = useCallback(async (periodo) => {
    setLoading(true);
    try {
      const res = await contratosAPI.getVigentes(periodo);
      setDatos(res.data);
    } catch (error) {
      console.error('Error cargando contratos:', error);
      showNotification?.('error', 'Costos Proveedor', errorDe(error, 'No se pudieron cargar los contratos'));
    } finally {
      setLoading(false);
    }
  }, [showNotification]);

  // Envuelve una llamada: notifica el error y devuelve true/false.
  const accion = useCallback(async (fn, porDefecto) => {
    try {
      await fn();
      return true;
    } catch (error) {
      console.error(porDefecto, error);
      showNotification?.('error', 'Costos Proveedor', errorDe(error, porDefecto));
      return false;
    }
  }, [showNotification]);

  const crearContrato = useCallback(
    (c) => accion(() => contratosAPI.crear(c), 'No se pudo guardar el contrato'), [accion]);
  const editarContrato = useCallback(
    (id, d) => accion(() => contratosAPI.editar(id, d), 'No se pudo guardar el contrato'), [accion]);
  const eliminarContrato = useCallback(
    (id) => accion(() => contratosAPI.eliminar(id), 'No se pudo eliminar el contrato'), [accion]);
  const guardarTarifa = useCallback(
    (id, t) => accion(() => contratosAPI.guardarTarifa(id, t), 'No se pudo guardar la tarifa'), [accion]);
  const deshacerAjuste = useCallback(
    (tarifaId) => accion(() => contratosAPI.deshacerAjuste(tarifaId), 'No se pudo deshacer el ajuste'), [accion]);
  const quitarHerramienta = useCallback(
    (id, appId) => accion(() => contratosAPI.quitarHerramienta(id, appId), 'No se pudo quitar la herramienta'), [accion]);

  return {
    datos, loading, loadVigentes,
    crearContrato, editarContrato, eliminarContrato,
    guardarTarifa, deshacerAjuste, quitarHerramienta
  };
};
